import React from "react";

type AlertProps = {
	type?: "info" | "warning" | "error" | "success";
	outline?: boolean;
	className?: string;
	children: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

function Alert({
	type = "info",
	children = null,
	outline = false,
	className = "",
	...props
}: AlertProps) {
	const baseClasses = "p-6 mb-4 text-md rounded shadow-sm";
	const typeBgClasses = {
		info: "bg-white text-primary-blue",
		warning: "bg-warning text-white",
		error: "bg-danger text-white",
		success: "bg-success text-white",
	};
	const typeClasses = {
		info: "border-primary-blue",
		warning: "border-warning",
		error: "border-danger",
		success: "border-success",
	};
	const typeOutlineClasses = {
		info: "border-4 border-primary-blue bg-white text-primary-blue",
		warning: "border-4 border-warning bg-white text-primary-blue",
		error: "border-4 border-danger bg-white text-primary-blue",
		success: "border-4 border-success bg-white text-primary-blue",
	};
	const _type = type || "info";
	return (
		<div
			className={`${baseClasses} ${
				typeClasses[_type]
			} ${className} ${outline ? typeOutlineClasses[_type] : typeBgClasses[_type]}`}
			role="alert"
			{...props}
		>
			{children}
		</div>
	);
}

export default Alert;
